import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { JobWrapper } from '@shared/components/job-wrapper/job-wrapper';

@Component({
  selector: 'ta-report-wrapper-page',
  template: `
    <ta-job-wrapper [visible]="true">
      <router-outlet />
    </ta-job-wrapper>
  `,
  imports: [RouterOutlet, JobWrapper]
})
export class ReportWrapperPage {}
